const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { MediaUpload, InspectorControls } = wp.blockEditor;
const { useSelect } = wp.data;
const {
	Button,
	TextControl,
	Panel,
	PanelBody,
	PanelRow,
	Icon,
	ColorPalette,
	ButtonGroup,
	SelectControl,
	ComboboxControl,
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;
import { useState } from "react";

const { __experimentalLinkControlSearchInput: LinkControlSearchInput } =
	wp.blockEditor;

registerBlockType(
	"qteblocks/product", // Name of the block with a required name space
	{
		title: "Produkt",
		description: "Visa en produkt (Intern produkt)",
		icon: "products", // Icon, from WP icons
		category: "qteblocks",

		attributes: {
			productId: {
				type: "number",
				default: 0,
			},
		},

		edit(props) {
			var attributes = props.attributes;

			const { products } = useSelect((select) => {
				const { getEntityRecords } = select("core");

				// Query args
				const globalComponentsQuery = {
					status: "publish",
					per_page: -1,
				};

				return {
					products: getEntityRecords(
						"postType",
						"product",
						globalComponentsQuery,
					),
				};
			});

			function getPostOptions(posts) {
				let options = [];
				if (posts) {
					options.push({ value: 0, label: "Välj en global komponent" });
					posts.forEach((post) => {
						options.push({ value: post.id, label: post.title.rendered });
					});
				} else {
					options.push({ value: 0, label: "Laddar ..." });
				}
				return options;
			}

			let productOptions = getPostOptions(products);

			return (
				<>
					<InspectorControls>
						<Panel>
							<PanelBody
								title="Inställningar"
								icon={<Icon icon="admin-generic" />}
								initialOpen={true}
							>
								<PanelRow>
									<ComboboxControl
										label="Välj produkt"
										onChange={(value) =>
											props.setAttributes({ productId: Number(value) ? Number(value) : 0 })
										}
										options={productOptions}
										onFilterValueChange={(inputValue) =>
											productOptions.filter((option) =>
												option.label
													.toLowerCase()
													.startsWith(inputValue.toLowerCase()),
											)
										}
										value={attributes.productId}
									/>
								</PanelRow>
							</PanelBody>
						</Panel>
					</InspectorControls>
					<ServerSideRender
						block="qteblocks/product"
						attributes={props.attributes}
					/>
				</>
			);
		},

		save(props) {
			return null; // See PHP side. This block is rendered on PHP.
		},
	},
);
